// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".spectrum--dark .spectrum-Rule--large {\n  background-color: rgb(227, 227, 227);\n}\n.spectrum--dark .spectrum-Rule--medium {\n  background-color: rgb(74, 74, 74);\n}\n.spectrum--dark .spectrum-Rule--small {\n  background-color: rgb(74, 74, 74);\n}\n", ""]);
// Exports
module.exports = exports;
